import withModalCustomWidth from "../hoc/withModalCustomWidth";
import ModalCustomWidtch from "../view/components/Modals/ModalCustomWidth";

export default withModalCustomWidth(ModalCustomWidtch);